export interface Country {
  code: string;
  name: string;
  flag: string;
}

export const europeanCountries: Country[] = [
  { code: "SE", name: "Sverige", flag: "🇸🇪" },
  { code: "NO", name: "Norge", flag: "🇳🇴" },
  { code: "DK", name: "Danmark", flag: "🇩🇰" },
  { code: "FI", name: "Finland", flag: "🇫🇮" },
  { code: "DE", name: "Tyskland", flag: "🇩🇪" },
  { code: "FR", name: "Frankrike", flag: "🇫🇷" },
  { code: "ES", name: "Spanien", flag: "🇪🇸" },
  { code: "IT", name: "Italien", flag: "🇮🇹" },
  { code: "PT", name: "Portugal", flag: "🇵🇹" },
  { code: "NL", name: "Nederländerna", flag: "🇳🇱" },
  { code: "BE", name: "Belgien", flag: "🇧🇪" },
  { code: "AT", name: "Österrike", flag: "🇦🇹" },
  { code: "CH", name: "Schweiz", flag: "🇨🇭" },
  { code: "PL", name: "Polen", flag: "🇵🇱" },
  { code: "CZ", name: "Tjeckien", flag: "🇨🇿" },
  { code: "HR", name: "Kroatien", flag: "🇭🇷" },
  { code: "GR", name: "Grekland", flag: "🇬🇷" },
  { code: "GB", name: "Storbritannien", flag: "🇬🇧" },
  { code: "IE", name: "Irland", flag: "🇮🇪" },
  { code: "SI", name: "Slovenien", flag: "🇸🇮" },
  { code: "SK", name: "Slovakien", flag: "🇸🇰" },
];

export function getCountryByCode(code: string): Country | undefined {
  return europeanCountries.find((c) => c.code === code);
}
